import React, { useEffect } from "react";
import { logAnalytics } from "@utils/analyticsUtil";
import styles from "./DontCry.module.scss";

const DontCry = ({
  title = "OOPS - 404",
  subtitle = "The page you requested doesn't exist.",
  message = "Please contact us if this seems to be a mistake.",
}) => {
  useEffect(() => {
    logAnalytics.error404(window.location.href);
  }, []);

  return (
    <div className={styles.dontCry}>
      <div className={styles.wrapper}>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default DontCry;
